    <div
      colspan="5"
      class="
        py-0
        block
        text-center
        white-space-nowrap
        w-full
        text-sm
      "
    >
      <div class="my-5 w-full text-center text-lg">
        {{
          'ADMIN.SUBSCRIPTION.NO_PRODUCT_ADDED' | translate
        }}
      </div>
      <button
        pButton
        pRipple
        type="button"
        label="{{
          'ADMIN.SUBSCRIPTION.ADD_PRODUCT' | translate
        }}"
        icon="fa fa-plus"
        (click)="addProductModal()"
        class="p-button-outlined text-sm surface-0"
        aria-label="add-product-button"
      ></button>
      <br /><br /><br />
      <img
        width="300"
        src="/assets/img/no-services-added.jpg"
        alt="No product added!"
      />
      </div>
